import { guideSteps } from "@/mocks/resources";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Guide() {
  return (
    <section id="guide" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="浏览指南"
          icon="ri-compass-3-line"
          title="如何高效浏览色虎资源"
          desc="为了让浏览更省时间，站点提供了分区导航与标签筛选。下面几步说明如何在页面内快速找到视频、写真或图片资源。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {guideSteps.map((step, index) => (
            <div
              key={step.title}
              className="relative p-5 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="font-heading text-4xl font-black text-primary-200 leading-none">
                0{index + 1}
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}